// extracted by mini-css-extract-plugin
module.exports = {"textButton":"_17duS","changeLocationModalWrapper":"_3qH1J","infoIconWrapper":"_2W65j"};